var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotijaoP13Cinza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1357 -2175.853)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1357 2176)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 -0.147)",
    fill: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.00030040740967 33.50009918212891 L 2.99970006942749 33.50009918212891 C 2.172760009765625 33.50009918212891 1.5 32.82693099975586 1.5 31.9995002746582 L 1.5 2.999699592590332 C 1.5 2.172759532928467 2.172760009765625 1.499999642372131 2.99970006942749 1.499999642372131 L 15.00030040740967 1.499999642372131 C 15.82723999023438 1.499999642372131 16.5 2.172759532928467 16.5 2.999699592590332 L 16.5 31.9995002746582 C 16.5 32.82693099975586 15.82723999023438 33.50009918212891 15.00030040740967 33.50009918212891 Z M 5.176799774169922 1.681499600410461 C 3.246510028839111 1.681499600410461 1.676100015640259 3.251909494400024 1.676100015640259 5.182199478149414 L 1.676100015640259 18.15119934082031 C 1.676100015640259 20.08099937438965 3.246510028839111 21.65099906921387 5.176799774169922 21.65099906921387 L 12.82320022583008 21.65099906921387 C 14.75300025939941 21.65099906921387 16.32299995422363 20.08099937438965 16.32299995422363 18.15119934082031 L 16.32299995422363 5.182199478149414 C 16.32299995422363 3.251909494400024 14.75300025939941 1.681499600410461 12.82320022583008 1.681499600410461 L 5.176799774169922 1.681499600410461 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.99789905548096 32.00009918212891 C 14.99862575531006 31.99942779541016 14.99935340881348 31.99868583679199 15 31.99795532226562 L 14.99997711181641 22.65184783935547 C 14.34157943725586 22.97157859802246 13.60295295715332 23.15099906921387 12.82320022583008 23.15099906921387 L 5.176799774169922 23.15099906921387 C 4.397073745727539 23.15099906921387 3.658463716506958 22.97165489196777 3.000054121017456 22.65205383300781 L 3.000079870223999 31.99804496765137 C 3.00070595741272 31.99874496459961 3.00140380859375 31.99945449829102 3.002100944519043 32.00009918212891 L 14.99789905548096 32.00009918212891 M 15.00030040740967 35.00009918212891 L 2.99970006942749 35.00009918212891 C 1.345659971237183 35.00009918212891 0 33.6540412902832 0 31.9995002746582 L 0 2.999699592590332 C 0 1.345659613609314 1.345659971237183 -4.089355343239731e-07 2.99970006942749 -4.089355343239731e-07 L 15.00030040740967 -4.089355343239731e-07 C 16.65434074401855 -4.089355343239731e-07 18 1.345659613609314 18 2.999699592590332 L 18 31.9995002746582 C 18 33.6540412902832 16.65434074401855 35.00009918212891 15.00030040740967 35.00009918212891 Z M 5.176799774169922 3.181499481201172 C 4.073609828948975 3.181499481201172 3.176100015640259 4.079009532928467 3.176100015640259 5.182199478149414 L 3.176100015640259 18.15119934082031 C 3.176100015640259 19.2538890838623 4.073609828948975 20.15099906921387 5.176799774169922 20.15099906921387 L 12.82320022583008 20.15099906921387 C 13.92588996887207 20.15099906921387 14.82299995422363 19.2538890838623 14.82299995422363 18.15119934082031 L 14.82299995422363 5.182199478149414 C 14.82299995422363 4.079009532928467 13.92588996887207 3.181499481201172 12.82320022583008 3.181499481201172 L 5.176799774169922 3.181499481201172 Z",
    stroke: "none",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.853)",
    fill: "gray",
    stroke: "gray",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 30,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 29,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 32.853)",
    fill: "gray",
    stroke: "gray",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 4,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H18.926",
    transform: "translate(1360.68 2196.503)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotijaoP13Cinza);
export default __webpack_public_path__ + "static/media/botijao-p13-cinza.1de74ad7e4ed16f6220c1fe92c398f53.svg";
export { ForwardRef as ReactComponent };